// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.md-white-background-vs {
  background: linear-gradient(180deg, #f7f9fc 0%, #ffffff 100%);
  border-radius: 16px;
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.08);
  width: 100%;
  max-width: 1900px;
  margin: 24px auto;
  min-height: 400px;
  padding: 24px 28px;
  box-sizing: border-box;
}

/* верхняя панель */
.header-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
  gap: 16px;
}

.view-section-main {
  padding: 0 8px;
}

.student-info {
  text-align: center;
  margin-top: 12px;
  margin-bottom: 12px;
}

.student-info p {
  margin: 4px 0;
  font-weight: 600;
  color: #002FA7;
  font-size: 17px;
}

/* фильтр */
.filter-section {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.filter-section label {
  font-weight: 600;
  color: #002FA7;
  font-size: 16px;
}

.course-filter {
  padding: 10px 14px;
  border-radius: 7px;
  font-size: 15px;
  min-width: 180px;
  background-color: #ffffff;
  color: #1f2933;
  border: 1px solid #d4dde8;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.06);
  transition: border-color 0.15s ease, box-shadow 0.15s ease, color 0.15s ease;
}

.course-filter:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.12);
  color: #002FA7;
}

/* курс */
.course-section {
  margin-bottom: 32px;
}

.course-section:last-child {
  margin-bottom: 0;
}

/* группы */
.groups-container {
  background-color: transparent;
  border-radius: 16px;
}

.course-title {
  color: #002FA7;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 18px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0, 47, 167, 0.12);
}

.v-groups-list {
  padding: 0;
  margin: 0;
}

.v-group-item {
  background: #ffffff;
  margin-bottom: 10px;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid rgba(0, 47, 167, 0.12);
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.05);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  transition: all 0.2s ease;
  min-height: 64px; /* уменьшена высота */
}

.group-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.1);
  border-color: rgba(0, 47, 167, 0.25);
}

.group-info {
  display: flex;
  align-items: center;
  flex-grow: 1;
  gap: 12px;
}

.group-code {
  font-weight: 700;
  color: #002FA7;
  font-size: 18px;
  padding: 5px 10px;
  border-radius: 8px;
  background: rgba(0, 47, 167, 0.06);
  min-width: 68px;
  text-align: center;
}

.group-name {
  color: #002FA7;
  font-size: 15px;
  line-height: 1.3;
  font-weight: 500;
}

/* блок с кнопками */
.group-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  border-radius: 8px;
  border: none;
  font-size: 13.5px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.25s ease;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.18);
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 47, 167, 0.25);
}

.action-icon {
  width: 18px;
  height: 18px;
  filter: brightness(0) invert(1);
}

.edit-btn, .view-btn, .export-btn {
  background: linear-gradient(135deg, #002FA7, #1e4fd1);
  color: white;
}

.export-btn:disabled {
  background: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* спиннер при экспорте */
.export-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255,255,255,0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  display: inline-block;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.no-groups {
  text-align: center;
  padding: 56px 20px;
  color: #94a3b8;
  font-size: 17px;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/md-components/ViewSection.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,6CAA6C;EAC7C,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;EAC5C,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,yBAAyB;EACzB,gBAAgB,EAAE,qBAAqB;AACzC;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".md-white-background-vs {\n  background: linear-gradient(180deg, #f7f9fc 0%, #ffffff 100%);\n  border-radius: 16px;\n  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.08);\n  width: 100%;\n  max-width: 1900px;\n  margin: 24px auto;\n  min-height: 400px;\n  padding: 24px 28px;\n  box-sizing: border-box;\n}\n\n/* верхняя панель */\n.header-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 28px;\n  gap: 16px;\n}\n\n.view-section-main {\n  padding: 0 8px;\n}\n\n.student-info {\n  text-align: center;\n  margin-top: 12px;\n  margin-bottom: 12px;\n}\n\n.student-info p {\n  margin: 4px 0;\n  font-weight: 600;\n  color: #002FA7;\n  font-size: 17px;\n}\n\n/* фильтр */\n.filter-section {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.filter-section label {\n  font-weight: 600;\n  color: #002FA7;\n  font-size: 16px;\n}\n\n.course-filter {\n  padding: 10px 14px;\n  border-radius: 7px;\n  font-size: 15px;\n  min-width: 180px;\n  background-color: #ffffff;\n  color: #1f2933;\n  border: 1px solid #d4dde8;\n  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.06);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, color 0.15s ease;\n}\n\n.course-filter:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.12);\n  color: #002FA7;\n}\n\n/* курс */\n.course-section {\n  margin-bottom: 32px;\n}\n\n.course-section:last-child {\n  margin-bottom: 0;\n}\n\n/* группы */\n.groups-container {\n  background-color: transparent;\n  border-radius: 16px;\n}\n\n.course-title {\n  color: #002FA7;\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 18px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid rgba(0, 47, 167, 0.12);\n}\n\n.v-groups-list {\n  padding: 0;\n  margin: 0;\n}\n\n.v-group-item {\n  background: #ffffff;\n  margin-bottom: 10px;\n  padding: 12px 16px;\n  border-radius: 8px;\n  border: 1px solid rgba(0, 47, 167, 0.12);\n  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.05);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  transition: all 0.2s ease;\n  min-height: 64px; /* уменьшена высота */\n}\n\n.group-item:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.1);\n  border-color: rgba(0, 47, 167, 0.25);\n}\n\n.group-info {\n  display: flex;\n  align-items: center;\n  flex-grow: 1;\n  gap: 12px;\n}\n\n.group-code {\n  font-weight: 700;\n  color: #002FA7;\n  font-size: 18px;\n  padding: 5px 10px;\n  border-radius: 8px;\n  background: rgba(0, 47, 167, 0.06);\n  min-width: 68px;\n  text-align: center;\n}\n\n.group-name {\n  color: #002FA7;\n  font-size: 15px;\n  line-height: 1.3;\n  font-weight: 500;\n}\n\n/* блок с кнопками */\n.group-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.action-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 9px 14px;\n  border-radius: 8px;\n  border: none;\n  font-size: 13.5px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  white-space: nowrap;\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.18);\n}\n\n.action-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(0, 47, 167, 0.25);\n}\n\n.action-icon {\n  width: 18px;\n  height: 18px;\n  filter: brightness(0) invert(1);\n}\n\n.edit-btn, .view-btn, .export-btn {\n  background: linear-gradient(135deg, #002FA7, #1e4fd1);\n  color: white;\n}\n\n.export-btn:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* спиннер при экспорте */\n.export-spinner {\n  width: 18px;\n  height: 18px;\n  border: 2px solid rgba(255,255,255,0.3);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  display: inline-block;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.no-groups {\n  text-align: center;\n  padding: 56px 20px;\n  color: #94a3b8;\n  font-size: 17px;\n  font-style: italic;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
